module.exports = __webpack_public_path__ + "static/media/023.f93d0757.jpg";